// Singleton module that tracks the timestamp of the user's last *real* input event.
// Used by:
//   • IdleTimeoutManager — to decide when to show the idle warning dialog.
//   • axiosInstance heartbeat — to avoid pinging /Auth/activity when the user is truly idle,
//     so the backend's IsOnline / Sleep status is accurate.

let _lastActivity = Date.now();

export function recordActivity(): void {
  _lastActivity = Date.now();
}

export function getLastActivityTime(): number {
  return _lastActivity;
}

export function getIdleSeconds(): number {
  return Math.floor((Date.now() - _lastActivity) / 1000);
}
